import { WebAPIClient } from "api";
import { ApiEndPoints } from "api/api-end-points";
import { APIResult } from "models/api-results";
import { BaseSearchParam } from "models/base-search-param";

import { Vehicle } from "../../models/vehicle/vehicle";
import { VehicleSearchParam } from "../../models/vehicle/vehicle-search-param";
import { Manufacturer, VehicleModel } from "models/vehicle/vehicle-model";

export async function GetMakes(): Promise<APIResult<Manufacturer[]>> {
    return await WebAPIClient.getData<Manufacturer[]>(ApiEndPoints.vehicle_makes_search);
}

export async function GetVehicleModels(): Promise<APIResult<VehicleModel[]>> {
    return await WebAPIClient.getData<VehicleModel[]>(ApiEndPoints.vehicle_model_search);
}


export async function CreateVehicle(param: Vehicle): Promise<APIResult<Vehicle>> {
    return await WebAPIClient.postData<Vehicle>(ApiEndPoints.vehicle_create, param);
}
export async function UpdateVehicle(param: Vehicle): Promise<APIResult<Vehicle>> {
    return await WebAPIClient.putData<Vehicle>(ApiEndPoints.vehicle_update.replace("{id}", (param?.id ?? 0).toString()), param);
}
export async function GetVehicles(param?: VehicleSearchParam, sort?: string, pageSize?: number, pageNumber?: number): Promise<APIResult<Vehicle[]>> {
    const searchParams = new BaseSearchParam(param, sort, pageSize, pageNumber);
    const queryString = searchParams.buildQueryString();

    const apiUrl = `${ApiEndPoints.vehicle_search}${queryString}`;
    return await WebAPIClient.getData<Vehicle[]>(apiUrl);
}